import { render, staticRenderFns } from "./SingleLayerComplexStyle.vue?vue&type=template&id=a9a367d6&scoped=true"
import script from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerComplexStyle.vue?vue&type=style&index=0&id=a9a367d6&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a9a367d6",
  null
  ,true
)

export default component.exports